module.exports = {"svg":{"$":{"width":"1000","height":"1000","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M11.576 547.9l282.848 126.404 409.285-383.26 137.057-128.341L361.234 714.22l362.77 146.362c8.742 3.327 18.733-1.33 21.855-10.644v-.666L999.985.374 10.327 514.636c-8.742 4.657-11.864 15.302-8.117 24.616 2.497 3.991 5.62 7.318 9.366 8.648zM360.61 999.626l141.112-161.663-141.112-61.206v222.869z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/guide 2.svg
// module id = 381
// module chunks = 0